import { render, staticRenderFns } from "./DefectTrendDialog.vue?vue&type=template&id=d39dfb42"
import script from "./DefectTrendDialog.vue?vue&type=script&lang=js"
export * from "./DefectTrendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports